import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LeadSource } from "services/redux/sales/corporate/leadDetails/action";
import { pocType } from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  getB2bDropDown,
} from "services/redux/sales/corporate/categoryDetails/action";
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import EditB2bAlliances from "./editB2bAlliances";
import { createAllianceLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { editAllianceLeadSubmit } from "services/redux/sales/editLead/action";
import { getDetails } from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  b2bDropDown: state.categoryDetlReducer.b2bDropDown,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  viewDetails: state.preSalesListReducer.viewDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationState,
      locationPinCode,
      createAllianceLead,
      getB2bDropDown,
      getCurrentLocation,
      excelUploadUrl,
      editAllianceLeadSubmit,
      getDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditB2bAlliances);
